import { inject, Injectable } from '@angular/core';
import { ApiDataAccess } from '@softline/core';
import { SOFTLINE_API_UPDATE_SHELF_LABEL_DEFINITION } from '../updated-article-label-print.api';
import { ShelfLabelDefinition, UpdateShelfLabelRequest } from '../types';

@Injectable()
export class ShelfLabelUpdateRepository {
  private readonly dataAccess = inject(ApiDataAccess);

  patch(id: string, body: UpdateShelfLabelRequest): Promise<ShelfLabelDefinition> {
    return this.dataAccess.patch(
      { path: SOFTLINE_API_UPDATE_SHELF_LABEL_DEFINITION, pathParams: { id } },
      body
    );
  }
}
